module.exports = __webpack_public_path__ + "img/photo_arbresha.84821639.png";